import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Fútbol americano",
    Baseball: "Béisbol",
    Basketball: "Baloncesto",
    Boxing: "Boxeo",
    Chess: "Ajedrez",
    Cricket: "Críquet",
    Darts: "Dardos",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Fútbol",
    "Formula 1": "Fórmula 1",
    "Gaelic Football": "Fútbol Gaélico",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Carreras de galgos",
    Handball: "Balonmano",
    "Ice Hockey": "Hockey sobre hielo",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Política",
    "Rugby League": "Liga de Rugby",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tenis de mesa",
    Tennis: "Tenis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} ganar",
    WinFirstRound: "{name} ganar el primer asalto",
    FirstTouchdown: "{name} marcar el primer toughdown",
    FirstTry: "{name} marcar el primero ensayo",
    TotalGoals: "{name} Total de Goles",
    TotalRuns: "{name} Total de Runs",
    TotalPoints: "{name} Total de Puntos",
    TopBatsman: "{name} Mejor Batsman",
    TopBowler: "{name} Mejor Bowler",
    FirstScore: "{name} Mejor Bowler"
  },
  PromoTexts: {
    Pick: "Hagan sus apuestas",
    Bet: "Apostar",
    Pays: "Retiradara"
  },
  DateTimeTexts: {
    Today: "Hoy dia",
    Tomorrow: "Mañana",
    Live: "En vivo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Hagan sus apuestas",
    Return: "Retiradara",
    Stake: "Apostar",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Goles a favor",
    shots: "Tiros",
    shots_on_target: "Tiros a puesta",
    ball_possession: "Posesión",
    goals_conceded: "Goles en contra",
    "Per match": "Por partido",
    H2H: "Enfrentamientos Directos",
    W: "V",
    D: "E",
    L: "D",
    T: "E",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
